namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumMandatorySFg {
        MandatorySalesmanFgNo = 0,
        MandatorySalesmanFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumMandatorySFg, 'GeniuzPOS.InitialData.PsPosStationEumMandatorySFg');
}
